import { Injectable } from "@nestjs/common";
import { InjectRepository } from "@nestjs/typeorm";
import { GantOrderFilter } from "@project-management-system/shared-models";
import { Repository } from "typeorm";
import { GantOrdersEntity } from "../entities/gant-orders.entity";



@Injectable()
export class GantOrdersRepository extends Repository<GantOrdersEntity> {

    constructor(@InjectRepository(GantOrdersEntity) private GantOrdersRepo: Repository<GantOrdersEntity>
    ) {
        super(GantOrdersRepo.target, GantOrdersRepo.manager, GantOrdersRepo.queryRunner);
    }

    async getPoNumber(req?: any): Promise<any[]> {
        console.log(req, "reqpo");
        const query = this.createQueryBuilder('o')
            .select(`DISTINCT po_number`);
        return await query.getRawMany();
    }

    // async getStylesDataRepo(): Promise<any[]> {
    //     return await this.createQueryBuilder('o')
    //         .select('DISTINCT o.style')
    //         .getRawMany();
    // }

    async getStylesDataRepo(): Promise<any[]> {
        const query = this.createQueryBuilder('o')
            .select(`DISTINCT style`)
        return await query.getRawMany()
    }

    async getorderDataForInfo(req?: GantOrderFilter): Promise<any[]> {
        console.log(req)
        const query = this.createQueryBuilder('o')
            .select(`*`)
        if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
        }
        if (req?.style) {
            query.andWhere(`o.style ='${req.style}'`);
        }
        query.andWhere(`o.status != 'ACCEPTED'`)
            .orderBy(` created_at`, 'DESC')
        return await query.getRawMany()
    }

    async getorderacceptanceData(req?: GantOrderFilter): Promise<any[]> {
        console.log(req, 'repo');
        const query = this.createQueryBuilder('o')
            .select('*');
        if (req?.poNumber !== undefined) {
            const poNumbers = req.poNumber.split(',').map(poNumber => poNumber.trim());
            query.andWhere(`o.po_number IN (:...poNumbers)`, { poNumbers });
        }
        if (req?.style) {
            query.andWhere(`o.style ='${req.style}'`);
        }
        query.andWhere(`o.status != 'ACCEPTED'`);
        return await query.getRawMany();
    }

}